<template>
  <div id="store-selector">
    <call />
    <pop-alert />
    <!-- header -->
     <top-bar title="店舗検索" backUrl="/" />
    <!-- main -->
    <main>
      <section style="background-color: #F7F8FA;">
        <div class="l-main l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body" v-if="shops">
            <div class="area-list-select mt-32">
              <div v-for="(area_name, area_id) in AREA_DEF" class="btn-select" @click="scrollToArea(area_id)" :key="area_id">
                {{area_name}}
              </div>
            </div>
            <template v-for="(area_name, area_id) in AREA_DEF">
              <section class="area" v-if="area_id in sortedShops" :key="area_id" :id="'area-' + area_id">
                <h2>{{area_name}}</h2>
                <div class="store-selector__shops">
                  <shop-button v-for="(shop, index) in shops[area_id]" :key="index" :shop_data="shop" :show_favorite="true" :onselect="onSelectShop" :onaccess="onAccessShop" :shop_follows="shop_follows" :onfavorite="onFavoriteShop" />
                </div>
              </section>
            </template>
            <store-select-alert :shop="selectedShop" :isChange="true" :show="showSelectAlert" :onclose="onCloseModal" :onFavoriteShop="onFavoriteShop" />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import PopAlert from "../components/PopAlert.vue";
import ShopButton from "../components/ShopButton.vue";
import StoreSelectAlert from "../components/StoreSelectAlert.vue";
import { getShopFollows, updateShopFollows, getShops } from "../store/firestore";
import { AREA_DEF, PREFECTURES_LIST } from "../config/const";
import firebase from "../common/firebaseProject";
import "vue-scroll-picker/dist/style.css"
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "StoreFavoriteSelect",
  components: {
    PopAlert,
    ShopButton,
    StoreSelectAlert,
    TopBar,
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
  data() {
    return {
      AREA_DEF: AREA_DEF,
      shops: undefined,
      selectedShop: null,
      showSelectAlert: false,
      shop_follows: [],
      processingFollow: false,
      showSelectShopModal:false,
      orgPrefecturesList:[],      
      prefecturesList:[],
      orgShops:undefined,
      currentArea: "1",
      currentpref: null,
    }
  },
  computed: {
    sortedShops() {
      return this.sortCities(this.shops);
    }
  },
  async created() {
    this.shops = await getShops();
    this.shop_follows = await getShopFollows(this.$store.state.userId);

    this.orgShops = this.shops
    this.initCheckArea()

  },
  watch: {
    currentArea: function (value) {
      console.log("currentArea",value)
      this.changeArea(value)
    },
  },
  methods: {
    onSelectShop(shopData) {
      this.selectedShop = shopData;
      this.showSelectAlert = true;
    },
    onAccessShop(shopData) {
      this.$router.push(`/location/${shopData.id}`)
    },
    onCloseModal() {
      this.showSelectAlert = false;
    },
    async onFavoriteShop(shopData) {
      if (this.processingFollow) return;
      this.processingFollow = true;
      try {
        if (this.shop_follows.indexOf(shopData.id) != -1) {
          this.shop_follows = this.shop_follows.filter((elem) => elem != shopData.id);
          const callable = firebase.functions('asia-northeast1').httpsCallable('unsubscribeTopic');
          await callable({
            topicId: `follow-store-${shopData.id}`
          })
          await updateShopFollows(this.shop_follows, this.$store.state.userId);
        } else {
          const callable = firebase.functions('asia-northeast1').httpsCallable('subscribeTopic');
          await callable({
            topicId: `follow-store-${shopData.id}`
          })
          this.shop_follows.push(shopData.id);
          await updateShopFollows(this.shop_follows, this.$store.state.userId);
        }
      } catch (e) {
        console.log(e);
      }
      this.processingFollow = false;
    },
    openSelectShopModal() {
      this.showSelectShopModal = true
    },
    closeSelectShopModal() {
      this.showSelectShopModal = false
    },
    initCheckArea() {
      this.orgPrefecturesList = []
      Object.keys(this.shops).forEach(area => {
        PREFECTURES_LIST.map(item =>{
          if (Number(item.area ) == Number(area)) {
            if (this.shops[area].some(shop => shop.address.startsWith(item.value))) {
                this.orgPrefecturesList.push(item);
            }
          }
        })
      });
      this.changeArea(1)
    },
    resetShops() {
      this.shops = this.orgShops
      this.currentArea= "1"
      this.currentpref= null
    },
    changeArea(value) {
      this.prefecturesList = [];
      this.currentpref = null
      this.prefecturesList = this.orgPrefecturesList.filter(item => Number(item.area) === Number(value))
      this.prefecturesList.unshift({value: "all",name:"すべて",area:value});
    },
    searchSelectShop() {
      console.log("this.currentArea",this.currentArea,this.currentpref)

      let shops = []
      if (this.currentpref == "all") {
        shops = this.orgShops[this.currentArea]
      } else {
        shops = this.orgShops[this.currentArea].filter(item => item.address.startsWith(this.currentpref))
      }
      console.log(shops)

      this.shops = []
      this.shops[this.currentArea] = shops

      this.closeSelectShopModal()
    },
    scrollToArea(currentArea) {
      this.currentArea = currentArea
      this.$nextTick(() => {
        const el = document.getElementById(`area-${currentArea}`);
        if (el) {
          window.scrollTo({ top: el.offsetTop - 40, behavior: 'smooth' });
        }
      });
    }
  }
});
</script>

<style>
  .vue-scroll-picker {
    height: 8em;
    margin-bottom: 12px;
  }
  .vue-scroll-picker-item {
    height: 2.2em !important;
    line-height: 2.2em !important;
  }
  .vue-scroll-picker-layer .top {
    background: linear-gradient(180deg, #f0f0f0 10%, rgba(240,240,240,0.7));
  }
  .vue-scroll-picker-layer .bottom {
   background: linear-gradient(0deg, #f0f0f0 10%, rgba(240,240,240,0.7)); 
  }

</style>